import React from "react";

const ContactUs = ({ handleSubmit, handleChange, formData }) => {
  return (
    <>
      <div className="container contact-form-wrapper">
        <h3>Tell us about yourself</h3>
        <form onSubmit={handleSubmit} className="responsive-form">
          <div className="form-group">
            <div className="row my-5">
              <div className="col-lg-6">
                <label htmlFor="firstName">First Name</label>
                <input
                  type="text"
                  id="firstName"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="col-lg-6">
                <label htmlFor="lastName">Last Name</label>
                <input
                  type="text"
                  id="lastName"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>
            <div className="row my-5">
              <div className="col-lg-6">
                <label htmlFor="email">Email</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="col-lg-6">
                <label htmlFor="phone">Phone</label>
                <input
                  type="text"
                  id="phone"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>
            <div className="row my-5">
              <div className="col-lg-12">
                <label htmlFor="message">Message</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                ></textarea>
              </div>
            </div>
          </div>

          <div className="button-group">
            <button className="btn-default btn-large rounded" type="submit">
              <div className="has-bg-light"></div>
              <span>Submit Now</span>
            </button>
          </div>
        </form>
      </div>
    </>
  );
};

export default ContactUs;
